import { Stack, styled } from '@mui/material';

export const StyledBox = styled(Stack)`
  position: absolute;
  z-index: 1500;
  right: 0;
  background-color: #ffffff;
  margin-top: 7rem;
  box-shadow: 8px 6px 40px -19px;
  width: 35rem;
  border-radius: 5px 0px 0px 5px;
  height: fit-content;
  border: 0.1px solid rgba(59, 89, 152, 0.1);
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
`;
